import { render, staticRenderFns } from "./Accesorial.vue?vue&type=template&id=dedaf344&"
import script from "./Accesorial.vue?vue&type=script&lang=js&"
export * from "./Accesorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../var/www/transport-app/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports